import React from 'react'
import { CheckboxControl } from 'spark-core-dx/components';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

export const Lock = () => {
    const { visualObject, setVisualObject } = useVisualFormContext();

    return (
        <div className="checkbox">
            <CheckboxControl value={visualObject?.IsLocked}
                onChange={() => {
                    setVisualObject(prev => ({
                        ...prev,
                        IsLocked: !visualObject?.IsLocked,
                    }));
                }} />
            Lock visual to ignore global filters
        </div>
    )
}
